import { upsertInto } from '@/lib/array-utils'
import { getStorageValue, STORAGE_KEYS, storages } from '@/lib/browserStorage'
import { ApplicationState } from '@/redux/stores/types'
import { CompanyPreference } from '@/travelsuit'

import { IAction } from '../actions/action-helpers'
import { AuthTypes, MyCompanyTypes } from '../actions/actions.types'

type MyCompanyState = ApplicationState['myCompany']

function myCompanyReducer(state: MyCompanyState = null, action: IAction): MyCompanyState {
	let preferences: CompanyPreference[]
	switch (action.type) {
		case MyCompanyTypes.GetMyCompany.SUCCESS:
		case MyCompanyTypes.UpdateMyCompanyLogo.SUCCESS:
		case MyCompanyTypes.SaveBmisNumberInMyCompany.SUCCESS:
		case MyCompanyTypes.AcceptTermsOfServices.SUCCESS:
			return {
				...action.payload,
				feature_flag: {
					...action.payload.feature_flag,
					...getStorageValue(storages.local, STORAGE_KEYS.COMPANY_FEATURE_FLAG_OVERRIDES),
				},
			}
		case MyCompanyTypes.DeleteBmisNumberFromCompany.SUCCESS:
			return state && { ...state, bmis: null }
		case MyCompanyTypes.UpdateMyCompanyPrefernces.SUCCESS:
			preferences = upsertInto<CompanyPreference>(
				state?.preferences ?? [],
				action.payload.preferences,
				(p) => p.preference_type,
			)
			return { ...state!, preferences }
		case AuthTypes.LogoutDone:
			return null
	}
	return state
}

export default myCompanyReducer
